// Articles de blog SEO (longue traîne) – Barnum Événement
const blogArticles = [
  {
    slug: 'taille-barnum-mariage-100-personnes',
    title: 'Quelle taille de barnum pour un mariage de 100 personnes ?',
    seoTitle: 'Quelle taille de barnum pour un mariage de 100 personnes ? | Barnum Événement',
    metaDescription:
      "Quelle surface de barnum prévoir pour 100 invités ? Calcul au m², tableau des dimensions (6x12, 8x12, 10x15), plan de salle, piste de danse et buffet. Guide Barnum Événement en Normandie.",
    excerpt:
      "Repas assis, cocktail, piste de danse et buffet : le calcul précis des m² à prévoir et les dimensions de barnum recommandées pour recevoir 100 invités.",
    date: '12 juin 2026',
    dateISO: '2026-06-12',
    category: 'Conseils',
    readingTime: '7 min',
    image:
      'https://images.unsplash.com/photo-1675376616537-c8aa9ddc9977?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwcmVjZXB0aW9uJTIwbWFycXVlZSUyMHRlbnR8ZW58MHx8fHwxNzkzMDE1MDM2fDA&ixlib=rb-4.1.0&q=85',
    imageAlt: 'Grand barnum blanc installé pour un mariage de 100 personnes',
    calculatorAfter: 1,
    intro:
      "C'est la question que l'on nous pose le plus souvent au téléphone : « combien de mètres carrés faut-il pour 100 invités ? ». La réponse dépend de trois choses : le type de repas, le mobilier choisi et tout ce que vous voulez loger sous la toile en plus des tables. Voici notre méthode de calcul, utilisée sur plus de 500 événements par an en Normandie.",
    sections: [
      {
        heading: 'La règle de base : combien de m² par personne ?',
        paragraphs: [
          "Pour un repas assis à table ronde ou rectangulaire, comptez 1,2 à 1,5 m² par invité. Cette surface inclut la chaise, l'espace de circulation derrière les convives et le passage du service. En dessous de 1,2 m², vos invités se touchent les coudes et les serveurs ne passent plus.",
          "Pour un cocktail debout, 0,8 à 1 m² par personne suffit. Pour une réception mixte (cocktail puis dîner assis), basez toujours votre calcul sur le repas assis, qui est le moment le plus gourmand en surface.",
        ],
        list: [
          'Repas assis, tables rondes de 8 à 10 personnes : 1,5 m² / invité',
          'Repas assis, tables rectangulaires en banquet : 1,2 m² / invité',
          'Cocktail debout avec mange-debout : 0,8 à 1 m² / invité',
          'Conférence, chaises en rangées : 0,7 m² / personne',
        ],
      },
      {
        heading: 'Le calcul pour 100 personnes, étape par étape',
        paragraphs: [
          "Partons d'un mariage classique : 100 invités, dîner assis, piste de danse et buffet dessert sous le barnum.",
          "100 invités × 1,5 m² = 150 m² pour la partie repas. Ajoutez ensuite les zones annexes : une piste de danse de 30 à 40 m² (comptez 0,3 à 0,4 m² par invité, tout le monde ne danse jamais en même temps), 10 à 15 m² pour le buffet et la desserte, et 10 m² pour le bar.",
          "Total : environ 200 à 215 m² pour recevoir confortablement 100 personnes avec repas assis et piste de danse. Si la piste de danse et le bar sont installés à l'extérieur ou sous une seconde structure, 150 à 160 m² suffisent.",
        ],
      },
      {
        heading: 'Tableau des dimensions recommandées',
        paragraphs: [
          "Voici les configurations que nous installons le plus souvent pour une centaine d'invités en Normandie.",
        ],
        table: {
          headers: ['Dimensions', 'Surface', 'Capacité repas assis', 'Capacité cocktail'],
          rows: [
            ['6 × 12 m', '72 m²', '45 à 55 personnes', '70 à 80 personnes'],
            ['8 × 12 m', '96 m²', '60 à 70 personnes', '95 à 110 personnes'],
            ['8 × 18 m', '144 m²', '95 à 105 personnes', '140 à 160 personnes'],
            ['10 × 15 m', '150 m²', '100 personnes + buffet', '150 à 170 personnes'],
            ['10 × 20 m', '200 m²', '100 personnes + piste de danse', '200 personnes'],
          ],
        },
      },
      {
        heading: 'Notre recommandation pour 100 invités',
        paragraphs: [
          "Pour un mariage de 100 personnes avec dîner assis, piste de danse et buffet sous la même toile, nous recommandons un barnum de 10 × 20 m (200 m²). C'est la configuration la plus confortable : vos invités circulent librement, le traiteur dispose d'un espace de service dédié et la piste reste bien dégagée.",
          "Si votre terrain est contraint en largeur, une solution de 8 × 18 m complétée par une petite structure de 4 × 8 m pour le bar et le buffet fonctionne tout aussi bien, et s'adapte mieux aux jardins étroits que l'on trouve souvent autour du Havre et de Rouen.",
        ],
      },
      {
        heading: 'Les erreurs à éviter',
        paragraphs: [
          "La première erreur est de calculer juste. Un barnum trop petit se ressent immédiatement : chaleur, bruit, service ralenti. La seconde est d'oublier les zones techniques : le traiteur a besoin d'une arrière-cuisine, souvent une tente de 3 × 6 m à l'arrière.",
        ],
        list: [
          "Oublier la hauteur libre : pour une structure décorée (tentures, lustres), prévoyez au moins 2,30 m sous sablière.",
          "Négliger le terrain : un sol en pente de plus de 5 % impose un plancher, qui modifie l'emprise au sol.",
          "Ne pas prévoir la météo normande : pensez aux parois amovibles, au chauffage en demi-saison et à un accès abrité entre le barnum et la maison.",
          "Sous-estimer les accès : il faut un passage de 1,20 m minimum entre les tables et une sortie dégagée.",
        ],
      },
      {
        heading: 'Et le budget ?',
        paragraphs: [
          "Pour un barnum de 200 m² livré, monté et démonté en Normandie, le budget d'un week-end se situe généralement entre 1 200 et 2 500 € selon les options (plancher, parois vitrées, éclairage, chauffage). Nos packs tout inclus regroupent structure, tables, chaises et vaisselle, ce qui revient souvent moins cher que la location séparée de chaque élément.",
        ],
      },
    ],
    faq: [
      {
        question: 'Quelle taille de barnum pour 100 personnes assises ?',
        answer:
          "Comptez 1,5 m² par invité pour un repas assis, soit environ 150 m² pour 100 personnes. Avec une piste de danse et un buffet sous la même structure, prévoyez 200 m², par exemple un barnum de 10 × 20 m.",
      },
      {
        question: 'Combien de mètres carrés par personne sous un chapiteau ?',
        answer:
          "1,2 à 1,5 m² par personne pour un repas assis, 0,8 à 1 m² pour un cocktail debout et 0,7 m² pour une conférence avec chaises en rangées.",
      },
      {
        question: 'Faut-il un plancher sous le barnum pour un mariage ?',
        answer:
          "Le plancher est recommandé si le terrain est en pente, humide ou irrégulier, et pour la piste de danse. Sur une pelouse plane et sèche, il reste facultatif.",
      },
      {
        question: 'Combien de temps avant faut-il réserver ?',
        answer:
          "Pour un mariage d'été en Normandie, réservez 6 à 12 mois à l'avance. Les week-ends de juin à septembre partent en priorité.",
      },
    ],
  },
  {
    slug: 'prix-location-barnum-normandie',
    title: 'Prix de location d\u2019un barnum en Normandie : le guide complet',
    seoTitle: 'Prix location barnum en Normandie : tarifs 2026 et budget réel | Barnum Événement',
    metaDescription:
      "Combien coûte la location d'un barnum en Normandie ? Tarifs par taille, coût du montage, de la livraison, du plancher et des options. Exemples de budgets pour 50, 100 et 200 personnes.",
    excerpt:
      "Tarifs par dimension, coût du montage et de la livraison, options utiles ou superflues : tout ce qui compose le prix réel de votre location de barnum.",
    date: '5 juin 2026',
    dateISO: '2026-06-05',
    category: 'Budget',
    readingTime: '6 min',
    image:
      'https://images.unsplash.com/photo-1768179123386-a86a85f1c35c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxvdXRkb29yJTIwZXZlbnQlMjB0ZW50JTIwc2V0dXB8ZW58MHx8fHwxNzkzMDE1MDM2fDA&ixlib=rb-4.1.0&q=85',
    imageAlt: 'Barnum blanc monté sur une pelouse pour une réception en Normandie',
    intro:
      "Un devis de location de barnum additionne toujours trois postes : la structure, la logistique (livraison, montage, démontage) et les équipements. Comprendre ce découpage permet de comparer les offres sans mauvaise surprise et d'arbitrer intelligemment sur les options.",
    sections: [
      {
        heading: 'Ce que vous payez vraiment',
        paragraphs: [
          "Le prix affiché d'un barnum correspond à la location de la structure pour un week-end. S'y ajoutent la livraison (fonction de la distance depuis notre dépôt de Gainneville, près du Havre), le montage et le démontage par notre équipe, puis les équipements : plancher, parois, éclairage, mobilier, vaisselle.",
          "En moyenne, la structure représente 50 à 60 % du budget, la logistique 20 à 25 %, et les équipements le reste.",
        ],
      },
      {
        heading: 'Grille indicative par dimension',
        paragraphs: [
          "Les fourchettes ci-dessous correspondent à une location de week-end, structure seule, montage inclus en Seine-Maritime.",
        ],
        table: {
          headers: ['Dimensions', 'Surface', 'Invités (assis)', 'Budget week-end'],
          rows: [
            ['4 × 8 m', '32 m²', '20 à 25', '180 à 320 €'],
            ['6 × 12 m', '72 m²', '45 à 55', '450 à 750 €'],
            ['8 × 12 m', '96 m²', '60 à 70', '650 à 1 000 €'],
            ['10 × 15 m', '150 m²', '95 à 105', '1 000 à 1 600 €'],
            ['10 × 20 m', '200 m²', '100 à 130', '1 400 à 2 300 €'],
          ],
        },
      },
      {
        heading: 'Les options : utiles ou superflues ?',
        paragraphs: [
          "Toutes les options ne se valent pas. Voici celles qui changent réellement l'expérience de vos invités, et celles dont on peut se passer.",
        ],
        list: [
          'Plancher : indispensable sur terrain en pente ou humide, sinon réservez-le à la piste de danse.',
          'Parois vitrées : très appréciées en bord de mer et autour d\u2019Étretat pour conserver la vue.',
          'Chauffage : incontournable d\u2019octobre à mai en Normandie, même pour une soirée d\u2019été fraîche.',
          'Éclairage guirlandes ou lustres : fort impact visuel pour un coût modéré.',
          'Moquette intégrale : jolie mais fragile en extérieur, souvent évitable.',
        ],
      },
      {
        heading: 'Trois exemples de budgets complets',
        paragraphs: [
          "Anniversaire de 50 personnes : barnum 6 × 12 m, 50 chaises, 6 tables, éclairage simple. Budget total de 700 à 1 100 €.",
          "Mariage de 100 personnes : barnum 10 × 20 m, plancher sur la piste de danse, mobilier complet, vaisselle et verrerie pour 100 couverts, éclairage décoratif. Budget total de 2 300 à 3 500 €.",
          "Événement professionnel de 200 personnes : deux structures, plancher intégral, parois vitrées, chauffage et mobilier. Budget total de 4 500 à 7 000 €.",
        ],
      },
      {
        heading: 'Comment faire baisser la facture',
        paragraphs: [
          "Choisir un pack tout inclus reste le levier le plus efficace : il évite de payer chaque élément séparément. Décaler votre événement hors saison (de septembre à mai) ou sur un jour de semaine permet aussi d'obtenir de meilleures conditions.",
        ],
        list: [
          'Privilégier un pack structure + mobilier + vaisselle plutôt que des locations isolées',
          'Réserver tôt pour sécuriser le tarif et la disponibilité',
          'Mutualiser la livraison si plusieurs prestations ont lieu le même week-end',
          'Assurer vous-même la mise en place des tables et chaises quand c\u2019est possible',
        ],
      },
    ],
    faq: [
      {
        question: 'Combien coûte la location d\u2019un barnum pour un week-end ?',
        answer:
          "Comptez de 180 à 320 € pour un barnum de 4 × 8 m, de 450 à 750 € pour un 6 × 12 m et de 1 400 à 2 300 € pour un 10 × 20 m, montage et démontage inclus en Seine-Maritime.",
      },
      {
        question: 'Le montage et la livraison sont-ils compris dans le prix ?',
        answer:
          "Chez Barnum Événement, la livraison, le montage et le démontage sont chiffrés dans le devis selon la distance et la taille de la structure. Les petites structures peuvent aussi être retirées sur place.",
      },
      {
        question: 'Faut-il verser une caution ?',
        answer:
          "Oui, une caution est demandée à la réservation. Elle est restituée après contrôle du matériel au retour.",
      },
      {
        question: 'Livrez-vous en dehors du Havre ?',
        answer:
          "Nous livrons dans toute la Normandie : Le Havre, Gainneville, Gonfreville-l'Orcher, Fécamp, Étretat, Honfleur, Rouen, Dieppe, Caen, Deauville et Lisieux notamment.",
      },
    ],
  },
  {
    slug: 'barnum-ou-chapiteau-que-choisir',
    title: 'Barnum ou chapiteau : quelle différence et lequel choisir ?',
    seoTitle: 'Barnum ou chapiteau : différences, avantages et lequel choisir | Barnum Événement',
    metaDescription:
      "Barnum, chapiteau, tente de réception ou tonnelle : différences de structure, de résistance au vent, de hauteur et de budget. Le guide pour choisir la bonne couverture pour votre événement.",
    excerpt:
      "Structure, hauteur, résistance au vent, décoration, budget : les vraies différences entre un barnum et un chapiteau, et comment trancher selon votre événement.",
    date: '28 mai 2026',
    dateISO: '2026-05-28',
    category: 'Conseils',
    readingTime: '5 min',
    image:
      'https://images.unsplash.com/photo-1775476793931-cb484f197760?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwcmVjZXB0aW9uJTIwbWFycXVlZSUyMHRlbnR8ZW58MHx8fHwxNzkzMDE1MDM2fDA&ixlib=rb-4.1.0&q=85',
    imageAlt: 'Intérieur d\u2019un chapiteau de réception avec tables rondes dressées',
    intro:
      "Dans le langage courant, « barnum » et « chapiteau » désignent souvent la même chose : une structure couverte temporaire. Techniquement, ce sont pourtant deux familles de matériel différentes, avec des usages, des hauteurs et des budgets distincts. Voici comment choisir sans se tromper.",
    sections: [
      {
        heading: 'Les différences techniques',
        paragraphs: [
          "Le barnum est une structure modulaire à ossature aluminium ou acier, à toit à deux pentes, généralement de 3 à 10 m de large, montée en quelques heures. Le chapiteau désigne une structure plus grande et plus haute, souvent à partir de 10 m de large, avec une sablière plus élevée et une capacité supérieure.",
          "La tente de réception se situe entre les deux, avec un esprit plus décoratif (toile tendue, formes arrondies). La tonnelle, elle, est une petite structure légère de 3 × 3 m, adaptée à un stand ou à un coin bar, pas à une réception.",
        ],
        table: {
          headers: ['Critère', 'Barnum', 'Chapiteau'],
          rows: [
            ['Largeur courante', '3 à 10 m', '10 à 25 m'],
            ['Hauteur sous sablière', '2 à 2,50 m', '2,50 à 4 m'],
            ['Capacité', '20 à 130 personnes', '100 à 500 personnes'],
            ['Montage', 'Quelques heures', 'Une demi-journée à un jour'],
            ['Usage type', 'Mariage, anniversaire, stand', 'Grande réception, événement pro'],
          ],
        },
      },
      {
        heading: 'Quel choix selon votre événement ?',
        paragraphs: [
          "Pour un mariage de 50 à 130 invités dans un jardin, un barnum est généralement le bon choix : il s'adapte aux terrains de taille moyenne, se monte vite et se décore très bien. Au-delà de 150 invités, ou pour une scène et un plafond haut, le chapiteau s'impose.",
        ],
        list: [
          'Jusqu\u2019à 60 invités : barnum de 6 × 12 m',
          '60 à 100 invités : barnum de 8 × 18 m ou 10 × 15 m',
          '100 à 150 invités : barnum de 10 × 20 m',
          'Au-delà de 150 invités : chapiteau ou association de plusieurs structures',
        ],
      },
      {
        heading: 'Vent, pluie et bord de mer',
        paragraphs: [
          "En Normandie, le vent est le vrai critère. Une structure professionnelle correctement lestée ou ancrée supporte des rafales bien supérieures à celles d'une tonnelle de jardin. Pour un événement en bord de mer, du Havre à Étretat, privilégiez une structure ancrée au sol, des parois complètes côté vent dominant et évitez les toiles légères.",
          "Côté pluie, vérifiez toujours que la toile est en PVC soudé (et non en polyester cousu) et que des gouttières relient les modules entre eux : c'est ce qui évite l'infiltration entre deux travées.",
        ],
      },
      {
        heading: 'Montage : soi-même ou par un professionnel ?',
        paragraphs: [
          "Les petites structures jusqu'à 4 × 8 m se montent à deux ou trois personnes en une heure. Au-delà, le montage demande une équipe formée, du matériel de lestage et une vérification des ancrages : confier cette étape à votre loueur vous protège juridiquement en cas d'incident et vous fait gagner une journée de préparation.",
        ],
      },
    ],
    faq: [
      {
        question: 'Quelle est la différence entre un barnum et un chapiteau ?',
        answer:
          "Le barnum est une structure modulaire de 3 à 10 m de large avec environ 2 à 2,50 m sous sablière, idéale jusqu'à 130 personnes. Le chapiteau est plus large (10 m et plus) et plus haut, adapté aux grandes réceptions de 100 à 500 personnes.",
      },
      {
        question: 'Un barnum résiste-t-il au vent et à la pluie ?',
        answer:
          "Oui, à condition d'utiliser une structure professionnelle en toile PVC, correctement lestée ou ancrée, avec des gouttières entre les modules. Les tonnelles légères de jardin ne conviennent pas à un événement.",
      },
      {
        question: 'Peut-on relier plusieurs barnums entre eux ?',
        answer:
          "Oui. Associer plusieurs modules permet de créer un espace repas, un bar et une arrière-cuisine séparés tout en restant abrité, une solution fréquente sur les terrains étroits.",
      },
      {
        question: 'Quelle structure choisir pour un événement professionnel ?',
        answer:
          "Pour un séminaire ou un salon, privilégiez une structure haute avec parois vitrées, plancher et éclairage, afin d'obtenir un rendu proche d'une salle.",
      },
    ],
  },
];

export const getArticle = (slug) => blogArticles.find((a) => a.slug === slug);

export default blogArticles;
